import { useMemo, useState } from 'react';
import SiteHeader from '@/components/feature/SiteHeader';
import SiteFooter from '@/components/feature/SiteFooter';
import BackToTop from '@/components/feature/BackToTop';
import SeoHead from '@/components/feature/SeoHead';
import Hero from '@/pages/home/components/Hero';
import HotExpose from '@/pages/home/components/HotExpose';
import LiveTicker from '@/pages/home/components/LiveTicker';
import TopicsSection from '@/pages/home/components/TopicsSection';
import LatestSection from '@/pages/home/components/LatestSection';
import InsightSection from '@/pages/home/components/InsightSection';
import FaqSection from '@/pages/home/components/FaqSection';
import BrandSection from '@/pages/home/components/BrandSection';
import ContactSection from '@/pages/home/components/ContactSection';
import { latestFeed } from '@/mocks/homeData';

const PAGE_SIZE = 6;

export default function Home() {
  const [activeCategory, setActiveCategory] = useState('all');
  const [query, setQuery] = useState('');
  const [visibleCount, setVisibleCount] = useState(PAGE_SIZE);

  const filteredFeed = useMemo(() => {
    const keyword = query.trim().toLowerCase();
    return latestFeed.filter((item) => {
      const matchCategory = activeCategory === 'all' || item.category === activeCategory;
      const matchKeyword =
        !keyword ||
        item.title.toLowerCase().includes(keyword) ||
        item.summary.toLowerCase().includes(keyword) ||
        item.categoryName.toLowerCase().includes(keyword);
      return matchCategory && matchKeyword;
    });
  }, [activeCategory, query]);

  const handleCategorySelect = (id: string) => {
    setActiveCategory(id);
    setVisibleCount(PAGE_SIZE);
    const target = document.getElementById('latest');
    if (target) target.scrollIntoView({ behavior: 'smooth', block: 'start' });
  };

  const handleCategoryChange = (id: string) => {
    setActiveCategory(id);
    setVisibleCount(PAGE_SIZE);
  };

  const handleQueryChange = (value: string) => {
    setQuery(value);
    setVisibleCount(PAGE_SIZE);
  };

  const handleLoadMore = () => {
    setVisibleCount((prev) => prev + PAGE_SIZE);
  };

  return (
    <>
      <SeoHead />
      <SiteHeader />
      <main>
        <Hero />
        <HotExpose />
        <LiveTicker />
        <TopicsSection activeCategory={activeCategory} onSelect={handleCategorySelect} />
        <LatestSection
          items={filteredFeed}
          total={latestFeed.length}
          activeCategory={activeCategory}
          onCategoryChange={handleCategoryChange}
          query={query}
          onQueryChange={handleQueryChange}
          visibleCount={visibleCount}
          onLoadMore={handleLoadMore}
        />
        <InsightSection />
        <FaqSection />
        <BrandSection />
        <ContactSection />
      </main>
      <SiteFooter />
      <BackToTop />
    </>
  );
}